export const SESSION_EXPIRE = 'SESSION_EXPIRE'
export const USER_VALID = 'USER_VALID'
export const ENABLE_RECAPTCHA = 'BL_ENABLE_RECAPTCHA'
export const RECAPTCHA_SITE_KEY = 'RECAPTCHA_SITE_KEY'
